// @flow

import React, { Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import type { ReconciliationStore } from '../../../types/shoppingCenterType';
import type { Store, StoreSearchCriteria } from '../../../types/apolloType';

import storeApi from '../../../network/api/storesApi';
import { MALL_PERF } from '../../../path/mallPath';
import SurfaceConvertor from '../../common/SurfaceConvertor';
import { getShoppingCenter } from '../../../utils/urlUtils';

type Props = {
  retailer: ReconciliationStore,
  deleteStore?: Function,
  searchCriterias: StoreSearchCriteria,
  logo: string,
  history: History,
  isBp: boolean,
  isLocomotive: boolean,
}

type State = {
  isFlip: boolean,
  sources: Store[],
}

class ImageHeader extends React.Component<Props, State> {
  static defaultProps = {
    deleteStore: null,
  };

  state = {
    isFlip: false,
    sources: [],
  };

  fetchSources = () => storeApi.fetchStoresSources(
    this.props.searchCriterias,
    this.props.retailer.codeRetailerProposition,
    this.props.retailer.isCustom,
  ).then(response => response.json())
    .then(responseJson => this.setState({ sources: responseJson }));

  flipTile = () => {
    if (!this.state.isFlip && this.state.sources.length < 1) {
      this.fetchSources();
    }
    this.setState({ isFlip: !this.state.isFlip });
  };

  countryOriginList = () => this.state.sources
    .map((source) => {
      const sc = getShoppingCenter(source.pcCode);
      if (!sc) {
        return null;
      }
      return sc.countryCode;
    }).reduce(
      (acc, curr) => {
        if (!curr || acc.includes(curr)) {
          return acc;
        }
        return acc.concat(curr);
      }
      , [],
    );

  render() {
    return (
      <div
        className={`image-header${this.state.isFlip ? ' flip' : ''}`}
      >
        <div className="front">
          <div
            className="image-header-section info-header badge-wrapper"
            style={{
              backgroundImage: this.state.isFlip ? 'none' : `url("${this.props.retailer.logo}")`,
            }}
          >
            {
              this.props.isBp &&
              <div className="badge-text bp">
                {I18n.t('tooltip.bp')}
              </div>
            }
            {
              this.props.retailer.isCustom &&
              <div className="badge">
                <i className="fal fa-user-edit" />
              </div>
            }
            {
              this.props.isLocomotive &&
              <div className="badge-text international">
                {I18n.t('tooltip.locomotive')}
              </div>
            }
            {
              this.props.retailer.isInternational &&
              <div className="badge-text international">
                {I18n.t('tooltip.international')}
              </div>
            }
          </div>
          {!this.state.isFlip &&
          <div className="image-header-section">
            <p className="tooltip-text">{this.props.retailer.retailerName}</p>
            {this.props.deleteStore &&
            <Fragment>
              <button
                className="rounded-button little-eye-button"
                onClick={() =>
                  this.props.deleteStore && this.props.deleteStore(this.props.retailer)
                }
              >
                <i className="fal fa-trash" />
              </button>
              <button
                className="rounded-button little-eye-button"
                onClick={this.flipTile}
              >
                <i className="fal fa-bars" />
              </button>
            </Fragment>
            }
          </div>
          }
        </div>
        <div className="back">
          {this.props.deleteStore &&
          <div className="little-btn back-btn">
            <button
              onClick={this.flipTile}
            >
              <i className="fal fa-arrow-left" />
            </button>
            <div className="country-container">
              {(this.countryOriginList()
                .map(countryOrigin => (
                  <div className="country-count">{countryOrigin}&nbsp;:&nbsp;
                    {
                      this.state.sources
                        .filter((source) => {
                          const sc = getShoppingCenter(source.pcCode);
                          return sc && sc.countryCode === countryOrigin;
                        })
                        .length
                    }
                  </div>
                )))}
            </div>
          </div>
          }
          <div className="source-table-legend">
            <div className="row">
              <div className="column large">Shopping Centre</div>
              <div className="column small">GLA</div>
              <div className="column medium">Fly to Gemini</div>
            </div>
          </div>
          <div className="source-table">
            {this.state.sources.map((source) => {
              const sc = getShoppingCenter(source.pcCode);
              return (
                <div className="row" key={source.codstr}>
                  <div className="column large">
                    {sc ? sc.name : source.pcCode}
                  </div>
                  <div className="column small">
                    <SurfaceConvertor value={source.gla} />
                  </div>
                  <button
                    className="column medium"
                    onClick={() => this.props.history.push(`${MALL_PERF}?store=${source.codstr}&mall=${sc.id}`)}
                  >
                    {sc ? <i className="fal fa-rocket" /> : ''}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ImageHeader);
